import React, { useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid, Typography } from "@mui/material";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import {
  formatNumber,
  getReservationDetailsObject,
} from "utils/utils";
import {
  generateInvoice,
  getBillingInvoiceDetails,
} from "redux/actions/BillingAction";
import CommonButton from "components/commonButton/CommonButton";
import CommonNoDataFound from "components/CommonNoDataFound/CommonNoDataFound";
import Loader from "components/loader/Loader";
import { tripDutySlipData } from "./BillingInvoiceData";

const BillingDutySlip = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location?.pathname?.split("/");
  const [searchParams] = useSearchParams();

  const params = Object.fromEntries([...searchParams]);

  const queryParams = {
    cityId: params?.cityId || "",
    cityName: params?.cityName || "",
    companyId: params?.companyId || "",
    companyName: params?.companyName || "",
    tripId: params?.tripId || "",
    page: params?.page || "",
    pageRowSize: params?.pageRowSize ||  params?.rowPerPage || "",
    status: params?.status || "",
    startDate: params?.startDate === "undefined" ? "" : params?.startDate ? params?.startDate : "",
    endDate: params?.endDate === "undefined" ? ""  : params?.endDate ? params?.endDate : "",
    magicToken: params?.magicToken || "",
    pageType: params?.pageType || "",
    search: params?.search || ""
  }

  useEffect(() => {
    if (pathName?.includes("operation")) {
      dispatch(getBillingInvoiceDetails(queryParams?.tripId, "private"));
    } else {
      dispatch(getBillingInvoiceDetails(queryParams?.magicToken, "public"));
    }
  }, []);

  const tripDetails = useSelector((state) => state.getBillingInvoiceDetails?.bilingInvoiceDetails?.data);
  const tripDetailsLoader = useSelector((state) => state.getBillingInvoiceDetails?.loading);

  const tripTypeDetails = getReservationDetailsObject(tripDetails);

  const tripDutySlipDetails = tripDutySlipData(tripDetails, tripTypeDetails)

    //handle back 
  const handleBack = () => {
    if(queryParams?.pageType === "manageInvoice") {
      navigate(`/manage-invoice/bookingdetails?id=${queryParams?.tripId}&startDate=${queryParams?.startDate}&endDate=${queryParams?.endDate}`);
    } else if(queryParams?.pageType) {
      navigate(`/operation/allrides/bookingdetails?id=${queryParams?.tripId}&startDate=${queryParams?.startDate}&endDate=${queryParams?.endDate}&type=allrides&tab=completed&page=${queryParams?.page}&rowPerPage=${queryParams?.pageRowSize}&search=${queryParams?.search}`);
    }
    else {
      navigate(`/operation/billing/billToCompany?companyId=${queryParams?.companyId}&companyName=${queryParams?.companyName}&cityId=${queryParams?.cityId}&cityName=${queryParams?.cityName}&status=${queryParams?.status}&page=${queryParams?.page}&pageRowSize=${queryParams?.pageRowSize}&startDate=${queryParams?.startDate}&endDate=${queryParams?.endDate}`)
    }
  }
  const handleRedirection = () =>{
    navigate(`/operation/billing/billToCompany?companyId=${queryParams?.companyId}&companyName=${queryParams?.companyName}&cityId=${queryParams?.cityId}&cityName=${queryParams?.cityName}&status=${queryParams?.status}&page=${queryParams?.page}&pageRowSize=${queryParams?.pageRowSize}&startDate=${queryParams?.startDate}&endDate=${queryParams?.endDate}`)
  }

  const handleGenerateInvoice = () => {
    if(queryParams?.pageType === "generateInvoice" || queryParams?.pageType === "manageInvoice") {
      const handleBack = queryParams?.pageType === "manageInvoice" 
        ? () => navigate(`/manage-invoice/bookingdetails?id=${queryParams?.tripId}&startDate=${queryParams?.startDate}&endDate=${queryParams?.endDate}`)
        : handleRedirection;
      dispatch(generateInvoice({tripId: queryParams?.tripId, generateType: "dutySlip,b2bPerforma", handleBack}));
    }else{
      window.open(tripDetails?.Invoices?.[0]?.dutySlip?.url, '_blank')
    }
  };

  const commonGridRender = (arrayData, gridSize) => {
    return(arrayData?.map((details, index) => {


      if (details.isTable && details.tableData) {
        return (
          <div key={index} className="ml-12 w-full">
            <h4 className="text-gray-600 text-base font-[400]">
              {details.title}
            </h4>
            <div className="mt-2.5 mb-5">
              <table className="w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-100">
                    {details.tableData.tableHeaders.map((header, headerIndex) => (
                      <th 
                        key={headerIndex} 
                        className="px-3 py-2 text-left border border-gray-300 text-gray-700 text-sm font-[400]"
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {details.tableData.tableData.map((guest, guestIndex) => (
                    <tr 
                      key={guestIndex} 
                      className={'bg-white'}
                    >
                      <td className="px-3 py-2 border border-gray-300 text-sm text-gray-700">
                        {guest.name}
                      </td>
                      <td className="px-3 py-2 border border-gray-300 text-sm text-gray-700">
                        {guest.phone}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );        
      } else {

      return (<Grid container item xs={gridSize?.xs} sm={gridSize?.sm} md={gridSize?.md} key={index} className="pb20">
        <Grid
          item
          xs={6}
          lg={5}
          xl={4}
          className="textleft"
          pl={6}
        >
          <Typography variant="body2" className="colorBlack op80">
            {details?.title}
          </Typography>
        </Grid>
        <Grid
          item
          xs={6}
          lg={7}
          xl={8}
          className="colorBlack textLeft"
        >
          <Typography variant="body2" className="pr10">{details?.value}</Typography>
        </Grid>
      </Grid>)
      }
  }))
  }

  const btnText = () => {
    if(queryParams?.pageType === "generateInvoice" || queryParams?.pageType === "manageInvoice") {
      return "Confirm"
    }
    return "Download"
  }

  return (
    <Grid container className="pt20 br20" justifyContent={"center"}>
      {tripDetailsLoader ? <Loader /> :
      <Grid item md={11}>
        <Box className="alignStart">
          {pathName?.includes("operation") && (
            <ArrowBackIosRoundedIcon
              className="font24 colorGrey mb20"
              role="presentation"
              onClick={handleBack}
            />
          )}
        </Box>
        <Grid container justifyContent={"space-between"} alignItems={"center"}>
          <Grid>
            <Typography className="fw500 pb10" variant="head5" component={"p"}>
              {tripDetails?.DriverProfile?.vendorName || ""}
            </Typography>
            <Typography className="pb20" variant="body2" component={"p"}>
              Website: {tripDetails?.vendorEmail || ""}&nbsp;&nbsp; Phone:&nbsp;
              {tripDetails?.vendorMobile || ""}
            </Typography>
          </Grid>
          {pathName?.includes("operation") &&  <CommonButton
            name={btnText()}
            iconType="download"
            iconPlace={queryParams?.pageType !== "generateInvoice" && queryParams?.pageType !== "manageInvoice" && "back"}
            btnClass="btnMedium btnSecondary btnYellow"
            onClick={handleGenerateInvoice}
          />
          }
         
        </Grid>

        <Grid className="invoiceBorder br20 mb40">
          <Grid container className="solidBorderBottomBlack pt20" item xs={12}>
            <Grid container item xs={12} md={6}>
            {commonGridRender(tripDutySlipDetails?.detailsArray1)}
            </Grid>

            <Grid
              container
              item
              xs={12}
              md={6}
              alignItems={"flex-start"}
              className="height100 flexColumn"
            >
              {commonGridRender(tripDutySlipDetails?.detailsArray2)}
            </Grid>
          </Grid>
          <Grid container className="solidBorderBottomBlack pt20" item xs={12}>
            <Grid container item xs={12}>
            {commonGridRender(tripDutySlipDetails?.detailsArray3, {xs:12, sm:6, md:4})}
            </Grid>
          </Grid>
          <Grid container className="solidBorderBottomBlack pt20" item xs={12}>
            <Grid container item xs={12}>
              {commonGridRender(tripDutySlipDetails?.detailsArray4, {xs:12, sm:6, md:4})}
            </Grid>
          </Grid>
          <Grid container className="solidBorderBottomBlack pt20" item xs={12}>
            <Grid container item xs={12} >
            {commonGridRender(tripDutySlipDetails?.detailsArray5, {xs:12, sm:6, md:4})}
            </Grid>
          </Grid>
          <Grid container className="solidBorderBottomBlack" item xs={12}>
            <Grid container item md={12}>
              <Grid container item md={4} className="pt20" flexDirection={'column'}>
                <Grid className="textleft" pl={6}>
                  <Typography className="colorBlack pb20">
                  <Typography component={"span"} variant="body2" className="colorBlack op80">Toll Charges</Typography>
                     &nbsp;&nbsp;
                    <Typography component={"span"} variant="body2" className="colorBlack">{formatNumber(Number(tripDetails?.Payments[0]?.tripPricingDetails?.breakdown?.find((item) => item.chargeType === "tollCharges")?.addedCharge ?? 0)) || 0}</Typography>
                  </Typography>
                </Grid>
                <Grid className="textleft" pl={6}>
                  <Typography className="colorBlack pb20">
                  <Typography component={"span"} variant="body2" className="colorBlack op80">Parking Charges</Typography>
                     &nbsp;&nbsp;
                    <Typography component={"span"} variant="body2" className="colorBlack">{formatNumber(Number(tripDetails?.Payments[0]?.tripPricingDetails?.breakdown?.find((item) => item.chargeType === "parkingCharge")?.addedCharge ?? 0)) || 0}</Typography>
                  </Typography>
                </Grid>
                <Grid className="textleft" pl={6}>
                  <Typography className="colorBlack pb20">
                  <Typography component={"span"} variant="body2" className="colorBlack op80">Interstate Tax</Typography>
                     &nbsp;&nbsp;
                    <Typography component={"span"} variant="body2" className="colorBlack">{formatNumber(Number(tripDetails?.Payments[0]?.tripPricingDetails?.breakdown?.find((item) => item.chargeType === "interstateTax")?.addedCharge ?? 0)) || 0}</Typography>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item md={8} className="instructionBorder pt20">
                <Grid item className="textleft" pl={6}>
                <Typography className="colorBlack pb20 alignStart">
                  <Typography variant="body2" className="colorBlack op80">Special Instruction</Typography>
                  <Typography  variant="body2" component={"p"} className="colorBlack pl20">{tripDetails?.note || ""}</Typography>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container className="solidBorderBottomBlack pt20" item xs={12}>
            <Grid container item xs={12} md={12}>
              {tripDutySlipDetails?.detailsArray6?.map((details, index) => (
                <Grid container item sm={12} md={3} key={index} className="pb20">
                  <Grid item sm={12} xl={6} className="textleft" pl={6}>
                    <Typography variant="body2" className="colorBlack op80">
                      {details?.title}
                    </Typography>
                  </Grid>
                  <Grid item sm={12} xl={6} className="colorBlack textLeft" pl={6}>
                    <Typography variant="body2">{details?.value}</Typography>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent={"center"}
            className="pt20 pb20"
            item
            xs={12}
          >
            <Typography className="fw500 colorPrimary textCenter">
            {tripDetails?.vendorAddress  +" Website: "+ tripDetails?.vendorEmail || ""}
            </Typography>
          </Grid>
        </Grid>

        <Grid container className="mb40">
          <Grid item xs={12} sm={6} className="height400 bgGrey justifyCenter">
            {tripDetails?.tripRouteImage?.url ? (
              <img src={tripDetails?.tripRouteImage?.url} alt="GoogleImage" className="width100 height100" />
            ) : (
              <CommonNoDataFound />
            )}
          </Grid>
          <Grid item xs={12} sm={6} className="p30">
            <Typography className="fw600 pb10">Guest Start Location</Typography>
            <Typography className="pb30">
              {tripDetails?.sourceAddress || ""}
            </Typography>
            <Typography className="fw600 pb10">Guest Drop Location</Typography>
            <Typography className="pb30">
              {tripTypeDetails?.tripAddress ||
                tripTypeDetails?.destinationAddress ||
                ""}
            </Typography>
            <Typography className="fw600 pb30">
              Distance Covered:&nbsp;&nbsp;&nbsp;
              {tripDetails?.actualDistance || 0} km
            </Typography>
            <Grid container>
              <Grid item xs={12} sm={6} className="justifyCenter">
                <Typography className="textCenter colorPrimary fw600">
                  Start Trip OTP Verified
                  <br />
                  {tripDetails?.TripOtp?.startOtp || ""}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} className="justifyCenter">
                <Typography className="textCenter colorPrimary fw600">
                  End Trip OTP Verified
                  <br />
                  {tripDetails?.TripOtp?.endOtp || ""}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* TODO: required an data from backend */}
        {tripDetails?.dutyTypeName === "Rental" && 
        tripDetails?.RoutingSummaries.length > 0 &&
        <Grid className="mb40">    
        <Typography variant="head5" className="fw600 pb30">
          Routing Summary Form Pick-Up To Drop
        </Typography>
        <Grid container className="solidBorderBottomBlack pb20 mt20">
          <Grid xs={12} sm={1} className="justifyCenter">
            <Typography variant="head6" className="textCenter">Sr. No.</Typography>
          </Grid>
          <Grid xs={12} sm={11}>
            <Typography variant="head6">Location</Typography>
          </Grid>
        </Grid>
        {tripDetails?.RoutingSummaries &&
          tripDetails?.RoutingSummaries?.map((routingData, index) => (
            <Grid container className="ptb20 dashedBorderBottom">
              <Grid xs={12} sm={1} className="justifyCenter">
                <Typography variant="body3" className="colorGrey textCenter">{index + 1}</Typography>
              </Grid>
              <Grid xs={12} sm={11}>  
                <Typography variant="body3" className="colorGrey">{routingData?.address}</Typography>
              </Grid>
            </Grid>
          ))}
      </Grid>
        }
      </Grid>
        }
    </Grid>
  );
};

export default BillingDutySlip;
